import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox'
import { Button, ButtonProps } from '@mui/material'
import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { SurveySchemaStatusEnum } from '../../../../../models/graphqlTypes'
import { SurveySchemaWithoutUser } from '../../types/surveyStore.types'
import { SendSurveyModal } from '../Surveys/SendSurveyModal'
import { useBlackButtonStyle } from '../../../../../utils/styles/useBlackButtonStyle'

interface Props extends ButtonProps {
  surveySchema: SurveySchemaWithoutUser
}

export const SendSurveyButton: React.FC<React.PropsWithChildren<Props>> = ({
  surveySchema,
  ...buttonProps
}) => {
  const { t } = useTranslation()
  const classes = useBlackButtonStyle()

  const [isSendSurveyModalOpen, setIsSendSurveyModalOpen] =
    useState<boolean>(false)

  const { watch } = useFormContext()
  const status = watch('status')

  return (
    <>
      {status === SurveySchemaStatusEnum.Active && (
        <Button
          classes={{ textPrimary: classes.textPrimary }}
          variant="text"
          startIcon={<ForwardToInboxIcon />}
          onClick={() => setIsSendSurveyModalOpen(true)}
          {...buttonProps}
          data-cy={'SendSurveyButton'}
        >
          {t('survey:buttons.sendSurvey')}
        </Button>
      )}

      {isSendSurveyModalOpen && (
        <SendSurveyModal
          open={isSendSurveyModalOpen}
          onClose={() => setIsSendSurveyModalOpen(false)}
          surveySchemaId={surveySchema.id}
        />
      )}
    </>
  )
}
